import styled from "styled-components";

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.82);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000;
    padding: 40px;
`;

export const CloseBtn = styled.button`
    position: absolute;
    top: 18px;
    right: 22px;
    border: none;
    background: transparent;
    color: #FFFFFF;
    font-size: 2rem;
    cursor: pointer;
    display: inline-flex;
    line-height: 1;
    opacity: 0.85;
    &:hover { opacity: 1; }
`;

export const Img = styled.img`
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
    border-radius: 6px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
`;
